export default __webpack_public_path__ + "static/media/6.3a646b6d.png";